import { render, staticRenderFns } from "./ListProductView.vue?vue&type=template&id=fa6a49d4&"
import script from "./ListProductView.vue?vue&type=script&lang=js&"
export * from "./ListProductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports